import { apiGet, apiPost, apiPut, apiDelete } from '../lib/api'

export const SIGN_UP_START = 'SIGN_UP_START'
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS'
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR'

export const TEST_SIGN_UP_START = 'TEST_SIGN_UP_START'
export const TEST_SIGN_UP_SUCCESS = 'TEST_SIGN_UP_SUCCESS'
export const TEST_SIGN_UP_ERROR = 'TEST_SIGN_UP_ERROR'

export const USERS_LOAD_START = 'USERS_LOAD_START'
export const USERS_LOAD_SUCCESS = 'USERS_LOAD_SUCCESS'
export const USERS_LOAD_ERROR = 'USERS_LOAD_ERROR'

export const USER_ADD_START = 'USER_ADD_START'
export const USER_ADD_SUCCESS = 'USER_ADD_SUCCESS'
export const USER_ADD_ERROR = 'USER_ADD_ERROR'

export const USER_LOAD_START = 'USER_LOAD_START'
export const USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS'
export const USER_LOAD_ERROR = 'USER_LOAD_ERROR'

export const USER_UPDATE_START = 'USER_UPDATE_START'
export const USER_UPDATE_SUCESS = 'USER_UPDATE_SUCESS'
export const USER_UPDATE_ERROR = 'USER_UPDATE_ERROR'

export const USERS_UPDATE_ME_START = 'USERS_UPDATE_ME_START'
export const USERS_UPDATE_ME_SUCCESS = 'USERS_UPDATE_ME_SUCCESS'
export const USERS_UPDATE_ME_ERROR = 'USERS_UPDATE_ME_ERROR'

export const USER_DELETE_START = 'USER_DELETE_START'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
export const USER_DELETE_ERROR = 'USER_DELETE_ERROR'

export const FOLLOW_USER_START = 'FOLLOW_USER_START'
export const FOLLOW_USER_SUCCESS = 'FOLLOW_USER_SUCCESS'
export const FOLLOW_USER_ERROR = 'FOLLOW_USER_ERROR'

export const USER_CLEAR = 'USER_CLEAR'
export const USERS_CLEAR = 'USERS_CLEAR'
export const STATS_CLEAR = 'STATS_CLEAR'
export const SET_NAME = 'SET_NAME'
export const SET_USER_INFO = 'SET_USER_INFO'

export const STATS_LOAD_START = 'STATS_LOAD_START'
export const STATS_LOAD_SUCCESS = 'STATS_LOAD_SUCCESS'
export const STATS_LOAD_ERROR = 'STATS_LOAD_ERROR'

export const SUBSCRIBE = 'SUBSCRIBE'

export const SUBSCRIBERS_LOAD_START = 'SUBSCRIBERS_LOAD_START'
export const SUBSCRIBERS_LOAD_SUCCESS = 'SUBSCRIBERS_LOAD_SUCCESS'
export const SUBSCRIBERS_LOAD_ERROR = 'SUBSCRIBERS_LOAD_ERROR'

export const PRACTICE_ADD_START = 'PRACTICE_ADD_START'
export const PRACTICE_ADD_SUCCESS = 'PRACTICE_ADD_SUCCESS'
export const PRACTICE_ADD_ERROR = 'PRACTICE_ADD_ERROR'

// TODO ERROR HANDLING
export const INVITE_USERS = 'INVITE_USERS'
export const GUIDE_POPUP_UPDATE = 'GUIDE_POPUP_UPDATE'

export const signUp = (body) => ({ getState, fetch }) => ({
  type: 'SIGN_UP',
  payload: apiPost({
    fetch,
    endpoint: 'users/sign-up',
    getState,
    body,
  }),
})

export const testSignUp = (body) => ({ getState, fetch }) => {
  return {
    type: 'TEST_SIGN_UP',
    payload: apiPost({
      fetch,
      endpoint: 'users/sign-up',
      getState,
      body,
    }),
  }
}

export const subscribe = (body) => ({ getState, fetch }) => ({
  type: 'SUBSCRIBE',
  payload: apiPost({
    fetch,
    endpoint: 'users/subscribe',
    getState,
    body,
  }),
})

export const setUserInfo = (data) => () => ({
  type: 'SET_USER_INFO',
  payload: data,
})

export const loadUsers = (query) => ({ getState, fetch }) => ({
  type: 'USERS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `users/search/${query}`,
    getState,
    query,
  }),
})

export const loadUser = (id) => ({ getState, fetch }) => ({
  type: 'USER_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `users/${id}`,
    getState,
  }),
})

export const createUser = (body) => ({ getState, fetch }) => ({
  type: 'USER_ADD',
  payload: apiPost({
    fetch,
    endpoint: 'users',
    getState,
    body,
  }),
})

export const updateUser = (body) => ({ getState, fetch }) => ({
  type: 'USER_UPDATE',
  payload: apiPut({
    fetch,
    endpoint: `users/${body.id}`,
    getState,
    body,
  }),
})

export const updateMe = (body) => ({ getState, fetch }) => ({
  type: 'USERS_UPDATE_ME',
  payload: apiPut({
    fetch,
    endpoint: 'users/me',
    getState,
    body,
  }),
})

export const deleteUser = (id) => ({ getState, fetch }) => ({
  type: 'USER_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `users/${id}`,
    getState,
  }),
})

export const followUser = (id) => ({ getState, fetch }) => ({
  type: 'FOLLOW_USER',
  payload: apiPost({
    fetch,
    endpoint: `users/follow/${id}`,
    getState,
  }),
})

export const setName = (name) => ({
  type: 'SET_NAME',
  payload: name,
})

export const clearUser = () => ({
  type: 'USER_CLEAR',
})

export const clearUsers = () => ({
  type: 'USER_CLEAR',
})

export const loadStats = () => ({ getState, fetch }) => ({
  type: 'STATS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'users/admin/stats',
    getState,
  }),
})

export const clearStats = () => ({
  type: 'STATS_CLEAR',
})

export const loadSubscribers = (query) => ({ getState, fetch }) => ({
  type: 'SUBSCRIBERS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'users/subscribers/all',
    getState,
    query,
  }),
})

export const inviteUsers = (userId, emails) => ({ getState, fetch }) => ({
  type: 'INVITE_USERS',
  payload: apiPost({
    fetch,
    endpoint: `users/${userId}/invite`,
    getState,
    body: {
      emails,
    },
  }),
})

export const savePractice = (body) => ({ getState, fetch }) => ({
  type: 'PRACTICE_ADD',
  payload: apiPost({
    fetch,
    endpoint: 'users/practice',
    getState,
    body,
  }),
})


// WEBPACK FOOTER //
// ./src/common/users/actions.js